module.exports = __webpack_public_path__ + "static/img/sevenab.cc5068ed.png";